import React, { useState, useEffect } from 'react';
import {
  Button,
  Container,
  TextField,
  Table,
  Modal,
  TableBody,
  TableCell,
  Box,
  styled,
  Typography,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  InputAdornment,
  Stack,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Tooltip,
  IconButton,
  useTheme,
} from '@mui/material';
import {
  Delete as DeleteIcon,
  Edit as EditIcon,
  Add as AddIcon,
  KeyboardDoubleArrowLeft as ChevronLeft,
  KeyboardDoubleArrowRight as ChevronRight,
  Close as CloseIcon,
  Search as SearchIcon,
} from '@mui/icons-material';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';
const CustomTableScrollbar = styled('div')(({ theme }) => ({
  '&::-webkit-scrollbar': {
    height: '6px',
    background: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.2)',
    borderRadius: '3px',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.3)',
  },
  scrollbarWidth: 'thin',
  scrollbarColor: `${theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.2)'} transparent`,
}));

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const CounsellorPerformance = () => {
  const theme = useTheme();
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [showUserGuideModal,setShowUserGuideModal]=useState(false)
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');

  const staticCounsellorPerformanceData = [
    { counsellorId: 1, counsellorName: 'John Doe', enquiry: 120, followUp: 85, conversion: 60, date: '2023-10-01' },
    { counsellorId: 2, counsellorName: 'Jane Smith', enquiry: 150, followUp: 95, conversion: 70, date: '2023-10-02' },
    { counsellorId: 3, counsellorName: 'Alice Johnson', enquiry: 200, followUp: 130, conversion: 90, date: '2023-10-03' },
    { counsellorId: 4, counsellorName: 'Bob Brown', enquiry: 90, followUp: 60, conversion: 45, date: '2023-10-04' },
    { counsellorId: 5, counsellorName: 'Charlie Davis', enquiry: 180, followUp: 110, conversion: 80, date: '2023-10-05' },
    { counsellorId: 6, counsellorName: 'Eve Wilson', enquiry: 130, followUp: 90, conversion: 65, date: '2023-10-06' },
  ];

  const [counsellors, setCounsellors] = useState(staticCounsellorPerformanceData);
  const [filteredData, setFilteredData] = useState(staticCounsellorPerformanceData);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  useEffect(() => {
    setFilteredData(
      counsellors.filter((counsellor) => {
        const matchesSearchTerm = counsellor.counsellorName.toLowerCase().includes(searchTerm.toLowerCase());
        const matchesFromDate = fromDate ? new Date(counsellor.date) >= new Date(fromDate) : true;
        const matchesToDate = toDate ? new Date(counsellor.date) <= new Date(toDate) : true;
        return matchesSearchTerm && matchesFromDate && matchesToDate;
      })
    );
  }, [searchTerm, fromDate, toDate, counsellors]);

  const paginatedData = filteredData.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage
  );

  return (
    <Container maxWidth={false} sx={{ width: '100%' }}>
    
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent:'space-between',
          mb: 1,
          p: 2,
          boxShadow: 'none',
          maxWidth: '100%',
          boxSizing: 'border-box',
        }}
      >
        <Box sx={{display:'flex',justifyContent:'center',alignItems:'center',gap:2}}>
        <TextField
                           variant="outlined"
                           placeholder="Search..."
                           value={searchTerm}
                           onChange={(e) => setSearchTerm(e.target.value)}
                           InputProps={{
                             startAdornment: (
                               <InputAdornment position="start">
                                 <SearchIcon
                                   sx={{
                                     color: theme.palette.primary.main,
                                     marginLeft: 1.5,
                                     fontSize: 24,
                                   }}
                                 />
                               </InputAdornment>
                             ),
                             endAdornment: searchTerm && (
                               <InputAdornment position="end">
                                 <IconButton
                                   size="small"
                                   onClick={() => setSearchTerm('')}
                                   sx={{
                                     color: "grey",
                                     marginRight: 1,
                                   }}
                                 >
                                   <CloseIcon fontSize="small" />
                                 </IconButton>
                               </InputAdornment>
                             ),
                             sx: {
                               borderRadius: '30px',
                               backgroundColor: theme.palette.mode === 'dark'
                                 ? 'rgba(255, 255, 255, 0.15)'
                                 : 'rgba(255, 255, 255, 1)',
                               boxShadow: theme.palette.mode === 'dark'
                                 ? '0 2px 8px rgba(0, 0, 0, 0.3)'
                                 : '0 2px 8px rgba(0, 0, 0, 0.1)',
                               '& .MuiOutlinedInput-notchedOutline': {
                                 border: `1px solid ${theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0, 0, 0, 0.1)'}`,
                               },
                               '&:hover': {
                                 backgroundColor: theme.palette.mode === 'dark'
                                   ? 'rgba(255, 255, 255, 0.2)'
                                   : 'rgba(240, 240, 240, 1)',
                                 boxShadow: theme.palette.mode === 'dark'
                                   ? '0 2px 12px rgba(0, 0, 0, 0.4)'
                                   : '0 2px 12px rgba(0, 0, 0, 0.15)',
                               },
                               '&.Mui-focused': {
                                 backgroundColor: theme.palette.mode === 'dark'
                                   ? 'rgba(255, 255, 255, 0.25)'
                                   : 'rgba(255, 255, 255, 1)',
                                 boxShadow: `0 0 0 3px ${theme.palette.primary.main}20`,
                                 '& .MuiOutlinedInput-notchedOutline': {
                                   border: `2px solid ${theme.palette.primary.main}`,
                                 },
                               },
                               paddingLeft: 1.5,
                               height: '50px',
                               transition: 'all 0.3s ease',
                             },
                           }}
                           sx={{
                             width: 350,
                             maxWidth: '100%',
                             '& .MuiInputBase-input': {
                               padding: '10px 14px',
                               color: theme.palette.text.primary,
                               fontWeight: 500,
                             },
                           }}
                         />
        
          <TextField
            label="From Date"
            type="date"
            variant="outlined"
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
            InputLabelProps={{ shrink: true }}
            sx={{
                mb: 3,
                mt:'20px',
                '& .MuiInputLabel-root': {
                  color: theme.palette.text.primary,
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: theme.palette.primary.main,
                },
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: theme.palette.text.primary,
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: theme.palette.primary.main,
                },
                '& .MuiInputBase-input[type="date"]::-webkit-calendar-picker-indicator': {
                  filter: theme.palette.mode === 'dark' ? 'invert(1)' : 'none',
                },
              }}
          />
          <TextField
            label="To Date"
            type="date"
            variant="outlined"
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
            InputLabelProps={{ shrink: true }}
            sx={{
                mb: 3,
                mt:'20px',
                '& .MuiInputLabel-root': {
                  color: theme.palette.text.primary,
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: theme.palette.primary.main,
                },
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: theme.palette.text.primary,
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: theme.palette.primary.main,
                },
                '& .MuiInputBase-input[type="date"]::-webkit-calendar-picker-indicator': {
                  filter: theme.palette.mode === 'dark' ? 'invert(1)' : 'none',
                },
              }}
          />
        </Box>
        <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <IconButton
                    onClick={() => setShowUserGuideModal(true)}
                    sx={{
                      width: 60,
                      height: 60,
                      borderRadius: '50%',
                      minWidth: 0, // Remove MUI's default padding
                    }}
                  >
                    <InfoOutlineIcon sx={{ fontSize: 30 }} />
                  </IconButton>
                </Box>
      </Box>
<Paper
        elevation={3}
        sx={{
          paddingBottom: 0,
          maxWidth: '100%',
          boxSizing: 'border-box',
          mx: 'auto',
          backgroundColor: theme.palette.background.paper,
          borderRadius: '16px',
        }}
      >
        <CustomTableScrollbar sx={{ width: '100%', overflowX: 'auto' }}>
          <TableContainer sx={{ width: '100%', borderRadius: '16px' }}>
            <Table
              sx={{
                '& .MuiTableHead-root .MuiTableCell-root': {
                  fontWeight: 'bold',
                  backgroundColor: theme.palette.primary.main,
                  color: 'white'
                },
              }}
            >
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem', minWidth: 70, whiteSpace: 'nowrap' }}>S.No</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem', minWidth: 180, whiteSpace: 'nowrap' }}>Counsellor Name</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem', minWidth: 120, whiteSpace: 'nowrap' }}>Enquiry</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem', minWidth: 120, whiteSpace: 'nowrap' }}>Follow Up</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem', minWidth: 120, whiteSpace: 'nowrap' }}>Conversion</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem', minWidth: 120, whiteSpace: 'nowrap' }}>Date</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {paginatedData.length > 0 ? (
                  paginatedData.map((counsellor, index) => (
                    <TableRow
                      key={counsellor.counsellorId}
                      sx={{
                        backgroundColor: index % 2 === 0 ? theme.palette.background.paper : theme.palette.background.paper,
                        '&:hover': {
                          backgroundColor: 'rgba(0, 0, 0, 0.04)',
                        },
                      }}
                    >
                      <TableCell sx={{ fontSize: '1rem', whiteSpace: 'nowrap' }}>{(page - 1) * rowsPerPage + index + 1}</TableCell>
                      <TableCell sx={{ fontSize: '1rem', whiteSpace: 'nowrap' }}>{counsellor.counsellorName}</TableCell>
                      <TableCell sx={{ fontSize: '1rem', whiteSpace: 'nowrap' }}>{counsellor.enquiry}</TableCell>
                      <TableCell sx={{ fontSize: '1rem', whiteSpace: 'nowrap' }}>{counsellor.followUp}</TableCell>
                      <TableCell sx={{ fontSize: '1rem', whiteSpace: 'nowrap' }}>{counsellor.conversion}</TableCell>
                      <TableCell sx={{ fontSize: '1rem', whiteSpace: 'nowrap' }}>{counsellor.date}</TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow sx={{
                backgroundColor: theme.palette.background.paper,
                '&:hover': {
                  backgroundColor: 'rgba(0, 0, 0, 0.04)',
                },
              }}>
                    <TableCell colSpan={6} align="center" sx={{ fontSize: '1rem', padding: '20px',wordSpacing:7}}>
                      No Data Found
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </CustomTableScrollbar>
      </Paper>

      {filteredData.length > 0 && (
        <Box
          sx={{
            maxWidth: '100%',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mt: 1,
            p: 2,
            mx: 'auto',
            pt: 2,
          }}
        >
          <Typography variant="body2" color={theme.palette.primary.main}>
            Page <strong>{page}</strong> of <strong>{Math.ceil(filteredData.length / rowsPerPage)}</strong>
          </Typography>
          <Stack direction="row" alignItems="center" spacing={1}>
            <IconButton
              onClick={() => handleChangePage(null, page - 1)}
              disabled={page === 1}
              sx={{
                color: theme.palette.primary.main,
                '&:hover': {
                  backgroundColor: theme.palette.action.hover,
                },
                '&.Mui-disabled': {
                  opacity: 0.3,
                },
                borderRadius: '50%',
                width: '36px',
                height: '36px',
              }}
            >
              <ChevronLeft />
            </IconButton>
            {[...Array(Math.ceil(filteredData.length / rowsPerPage))].map((_, index) => (
              <IconButton
                key={index + 1}
                onClick={() => handleChangePage(null, index + 1)}
                sx={{
                  width: '36px',
                  height: '36px',
                  borderRadius: '50%',
                  backgroundColor: page === index + 1 ? theme.palette.primary.main : 'transparent',
                  color: page === index + 1 ? theme.palette.primary.contrastText : theme.palette.text.primary,
                  '&:hover': {
                    backgroundColor: page === index + 1 ? theme.palette.primary.dark : theme.palette.action.hover,
                  },
                }}
              >
                {index + 1}
              </IconButton>
            ))}
            <IconButton
              onClick={() => handleChangePage(null, page + 1)}
              disabled={page >= Math.ceil(filteredData.length / rowsPerPage)}
              sx={{
                color: theme.palette.primary.main,
                '&:hover': {
                  backgroundColor: theme.palette.action.hover,
                },
                '&.Mui-disabled': {
                  opacity: 0.3,
                },
                borderRadius: '50%',
                width: '36px',
                height: '36px',
              }}
            >
              <ChevronRight />
            </IconButton>
            <FormControl size="small" sx={{ minWidth: 100, ml: 1 }}>
              <InputLabel id="rows-per-page-label" sx={{ color: theme.palette.text.primary }}>Rows</InputLabel>
              <Select
                labelId="rows-per-page-label"
                value={rowsPerPage}
                onChange={handleChangeRowsPerPage}
                label="Rows"
                sx={{
                  height: '36px',
                  color: theme.palette.text.primary,
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.text.primary,
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.primary.main,
                  },
                }}
              >
                <MenuItem value={5}>5</MenuItem>
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={20}>20</MenuItem>
                <MenuItem value={30}>30</MenuItem>
              </Select>
            </FormControl>
          </Stack>
        </Box>
      )}

      <Snackbar
        open={openSnackbar}
        autoHideDuration={4000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={() => setOpenSnackbar(false)} severity="success" sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
      <Modal
        open={showUserGuideModal}
        onClose={() => setShowUserGuideModal(false)}
        BackdropProps={{ style: { backgroundColor: 'rgba(0, 0, 0, 0.8)' } }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 800,
            bgcolor: 'background.paper',
            borderRadius: '16px',
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          {/* Header */}
          <Box
            sx={{
              backgroundColor: theme.palette.primary.main,
              padding: '12px 16px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              position: 'relative',
            }}
          >
            <Typography variant="h4" sx={{ color: '#fff', fontWeight: 'bold' }}>
              Counsellor Performance - User Guide
            </Typography>
            <IconButton
              onClick={() => setShowUserGuideModal(false)}
              sx={{ color: '#fff', position: 'absolute', right: 14 }}
            >
              <CloseIcon />
            </IconButton>
          </Box>

          {/* Scrollable Content */}
       <CustomTableScrollbar sx={{ maxHeight: '70vh', overflowY: 'auto', padding: '20px' }}>
  {/* Section 1: Search Counsellors */}
  <Typography
    variant="body1"
    sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mb: 1 }}
  >
    ➤ Follow these steps to search for counsellor performance records:
  </Typography>
  <ul style={{ marginLeft: '20px', lineHeight: '1.8', cursor: 'pointer' }}>
    <li>
      Use the search bar located at the top-left of the table.
    </li>
    <li>
      Enter the <strong>Counsellor Name</strong> (or part of the name) to filter the records.
    </li>
    <li>
      The table will automatically update to display matching performance records.
    </li>
  </ul>
  <Typography variant="body2" sx={{ mt: 2, color: theme.palette.text.primary }}>
    ⚠️ Note: The search is case-insensitive and filters by Counsellor Name.
  </Typography>

  {/* Section 2: Filter by Date Range */}
  <Typography
    variant="body1"
    sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mt: 3, mb: 1 }}
  >
    ➤ Follow these steps to filter records by date range:
  </Typography>
  <ul style={{ marginLeft: '20px', lineHeight: '1.8', cursor: 'pointer' }}>
    <li>
      Use the <strong>"From Date"</strong> and <strong>"To Date"</strong> fields located next to the search bar.
    </li>
    <li>
      Select a start date in <strong>From Date</strong> and an end date in <strong>To Date</strong>.
    </li>
    <li>
      The table will automatically filter records that fall within the selected date range.
    </li>
    <li>
      To remove the date filter, clear both date fields.
    </li>
  </ul>
  <Typography variant="body2" sx={{ mt: 2, color: theme.palette.text.primary }}>
    ⚠️ Note: Dates are inclusive, and date filtering works together with the search filter for precise results.
  </Typography>

  {/* Section 3: View Performance Data */}
  <Typography
    variant="body1"
    sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mt: 3, mb: 1 }}
  >
    ➤ Understanding the table columns:
  </Typography>
  <ul style={{ marginLeft: '20px', lineHeight: '1.8', cursor: 'pointer' }}>
    <li>
      <strong>Counsellor Name:</strong> The name of the counsellor.
    </li>
    <li>
      <strong>Enquiry:</strong> Total number of enquiries handled.
    </li>
    <li>
      <strong>Follow Up:</strong> Number of follow-ups conducted.
    </li>
    <li>
      <strong>Conversion:</strong> Number of successful conversions achieved.
    </li>
    <li>
      <strong>Date:</strong> The date on which the performance data was recorded.
    </li>
  </ul>
  <Typography variant="body2" sx={{ mt: 2, color: theme.palette.text.primary }}>
    ⚠️ Note: This is a read-only view. Editing or deleting records is not available in this module.
  </Typography>

  {/* Section 4: Pagination */}
  <Typography
    variant="body1"
    sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mt: 3, mb: 1 }}
  >
    ➤ Follow these steps to navigate the performance list:
  </Typography>
  <ul style={{ marginLeft: '20px', lineHeight: '1.8', cursor: 'pointer' }}>
    <li>
      Use the pagination controls at the bottom of the table to browse through records.
    </li>
    <li>
      Click the left (<strong>&lt;</strong>) or right (<strong>&gt;</strong>) arrows to move between pages.
    </li>
    <li>
      Click on a specific page number to jump directly to that page.
    </li>
    <li>
      Change the number of rows displayed per page using the dropdown menu (for example, 5, 10, 20, or 30 rows).
    </li>
  </ul>
  <Typography variant="body2" sx={{ mt: 2, color: theme.palette.text.primary }}>
    ⚠️ Note: Pagination applies after search and date filters, and only the selected number of rows per page will be displayed.
  </Typography>

  {/* Bottom Close Button */}
  <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
    {/* Optional close button if required */}
  </Box>
</CustomTableScrollbar>

        </Box>
      </Modal>
    </Container>
  );
};

export default CounsellorPerformance;
